import { instanceOf } from 'prop-types';

import { Box } from 'components/blueprint';

import { Avatar } from './Avatar';
import { BaseContentBox } from './content-box/BaseContentBox';
import { useSafeLabel } from 'hooks';
import { ReplyMeta } from './ReplyMeta';
import messages from './messages';
import { ReplyWrapper } from './ReplyWrapper';
import { ReplyMetaTime } from './ReplyMetaTime';

/**
 * ChatbotBaseReplyBox
 * A template for displaying plain text chatbot reply
 */
export const ChatbotBaseReplyBox = ({ datetime, children }) => {
  const safeLabel = useSafeLabel();

  return (
    <ReplyWrapper>
      <Avatar iconName="ChatAi" />
      <Box>
        <ReplyMeta role={safeLabel(messages.roleChatbot)} time={datetime} />
        <BaseContentBox flexDirection="column">{children}</BaseContentBox>
        <ReplyMetaTime datetime={datetime} />
      </Box>
    </ReplyWrapper>
  );
};

ChatbotBaseReplyBox.propTypes = {
  /**
   * Datetime of the reply
   */
  datetime: instanceOf(Date).isRequired,
};
